import { render, staticRenderFns } from "./QuizResult.vue?vue&type=template&id=8feb128c&scoped=true&"
import script from "./QuizResult.vue?vue&type=script&lang=ts&"
export * from "./QuizResult.vue?vue&type=script&lang=ts&"
import style0 from "./QuizResult.vue?vue&type=style&index=0&id=8feb128c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8feb128c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
